import React from 'react'
import Routes from './Components/routes/Routes.js'

export default function App() {
  return <Routes />
}
